import { CSSObject } from "styled-components";

//App
import { StylesProps } from "../../../../types";
import { vfxTheme } from "../../VFX-UI/Theme/theme";

export const formBackGroundStyles = (): CSSObject => {
  return {
      padding: `${vfxTheme.spaceUnits.sp01}px`,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  };
};
